export const LOCALE_CHANGED = 'LOCALE_CHANGED';

export function langChange(currentLocale, availableLocales) {
  return {
    type: LOCALE_CHANGED,
    currentLocale,
    availableLocales,
  };
}
